import styles from "./ErrorPage.module.css";
import {Button, Divider, Form, Image, Input, Select, Spin} from "antd";
import logoBlue from "../../../../img/tillit_logo_blue.svg";
import React from "react";

const ErrorPage = ({ error, resetErrorBoundary }) => {
    return (
        <div className='error-page' style={{backgroundColor: `var(--background)`, height: "100vh"}}>
            <div className={styles.error_wrap}>
                <Image
                    style={{width: "100px"}}
                    className={styles.login_logo}
                    preview={false}
                    src={logoBlue}
                />
                <div className={styles.error_title}>
                    <span>Uh oh...</span>
                </div>
                <div className={styles.login_form}>
                    <p className='error-msg'>
                        Unfortunately an unexpected error has occurred. Please try clicking the refresh page button to
                        reload the
                        application.{' '}
                    </p>
                    <p className='error-msg'>
                        If the issue persists, please contact application administrators.
                    </p>
                </div>
                <div>
                    <Button
                        shape="default"
                        block
                        type="primary"
                        htmlType="submit"
                        className={styles.error_wrap_button}
                        onClick={resetErrorBoundary}
                    >
                        Refresh page
                    </Button>
                </div>
            </div>
        </div>
)
    ;
};

export default ErrorPage;